import React from 'react'
import { NavLink } from 'react-router-dom'
import { FooterStyle, Widget } from '../widgetStyles/Styles'

export const Footer = () => (
    <footer className="tr-bg pd-lr pd-tb">
        <div className="wrapper">
            <FooterStyle>
                <div>
                    <div className="link_pr fwb fs-n">About</div>
                    <NavLink to="/crowd-detection/about">About us</NavLink>
                    <NavLink to="/crowd-detection/careers">Careers</NavLink>
                    <NavLink to="/crowd-detection/corporate-sales">Corporate sales</NavLink>
                    <NavLink to="/crowd-detection/how-to-buy">How to Buy</NavLink>
                </div>
                <div>
                    <div className="link_pr fwb fs-n">Support</div>
                    <NavLink to="/crowd-detection/contacts">Contacts</NavLink>
                    <NavLink to="/crowd-detection/returns">Returns</NavLink>
                    <NavLink to="/crowd-detection/warranty">Warranty</NavLink>
                    <NavLink to="/crowd-detection/product-registration">Product Registration</NavLink>
                    <NavLink to="/crowd-detection/help">Help</NavLink>
                </div>
                <div>
                    <div className="link_pr fwb fs-n">Legal</div>
                    <NavLink to="/crowd-detection/privacy">Privacy</NavLink>
                    <NavLink to="/crowd-detection/Terms">Terms</NavLink>
                    <NavLink to="/crowd-detection/Patents">Patents</NavLink>
                </div>
                <div>
                    <div className="link_pr fwb fs-n">Other</div>
                    <NavLink to="/crowd-detection/account">Account</NavLink>
                    <NavLink to="/crowd-detection/affiliate-program">Affiliate Program</NavLink>
                    <NavLink to="/crowd-detection/partners">Partners</NavLink>
                </div>
            </FooterStyle>
            <div className="df jcc mt mb">
                <img className="social_icons" src="./img/social/facebook.svg" alt="facebook" />
                <img className="social_icons" src="./img/social/twitter.svg" alt="twitter" />
                <img className="social_icons" src="./img/social/skype.svg" alt="skype" />
                <img className="social_icons" src="./img/social/github.png" alt="github" />
                <img className="social_icons" src="./img/social/gmail.png" alt="gmail" />
            </div>
            <div className="df jcc mb">
                <img className="payments_icons" src="./img/payments/visa.jpg" alt="visa" />
                <img className="payments_icons" src="./img/payments/apple-pay.png" alt="apple pay" />
                <img className="payments_icons" src="./img/payments/mastercard.png" alt="mastercard" />
                <img className="payments_icons" src="./img/payments/paypal.png" alt="paypal" />
            </div>
            <div className="df jcc tac mt mb">Copyright © 2022 VegasML Team&nbsp; •<a href="mailto:vegasmlteam@gmail.com">vegasmlteam@gmail.com</a></div>
        </div>
    </footer>
)


